var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsv-modals"},[(_vm.showOneTimeAccessRequestModal)?_c('one-time-access-modal',{on:{"close":function($event){_vm.showOneTimeAccessRequestModal = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }